import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import Pagination_Holder from "../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../features/admin/role_permmission/owner/Slice";
import { FixIDS } from "../../../../../utils/fixIDS";

const Table = ({ setEdit, setEditId, searchName }) => {
  const alldata = useSelector((state) => state.usermanagement.Owner);
  const dispatch = useDispatch();

  const [onPageChange, setonPageChange] = useState(1);
  const permissions = useSelector((state) => state.auth.permissions);
  const haveEditPermission = permissions?.includes(FixIDS.User.Edit);

  useEffect(() => {
    fetch(onPageChange);
  }, [searchName, onPageChange]);

  const fetch = async (page = 1) => {
    await dispatch(
      GetAll({
        name: searchName,
        page: page,
        per_page: alldata?.per_page,
      }),
    );
  };

  const handlePageChange = (page) => {
    setonPageChange(page);
  };

  const getStatusClass = (status) => {
    if (status === true || status === "true" || status === 1) return "green";
    if (status === false || status === "false" || status === 0) return "red";
    return "";
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Unique ID</th>
                <th>Role Name</th>
                <th>Name</th>
                <th>Gender</th>
                <th>Contact No</th>
                <th>Email</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {Array.isArray(alldata?.data) && alldata.data.length > 0 ? (
                alldata.data.map((row, index) => (
                  <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                    <td>
                      {(alldata?.current_page - 1) * (alldata?.per_page || 0) +
                        index +
                        1}
                    </td>
                    <td>{row?.unique_id || "-"}</td>
                    <td>{row?.Role?.name || "-"}</td>
                    <td>{row?.name || "-"}</td>
                    <td>{row?.Gender?.name || "-"}</td>
                    <td>{row?.contact_no || "-"}</td>
                    <td>{row?.email || "-"}</td>
                    <td className={`status ${getStatusClass(row?.status)}`}>
                      {row?.status === true || row?.status === "true"
                        ? "Active"
                        : "Inactive"}
                    </td>
                    {haveEditPermission && (
                      <td>
                        <div
                          className="edit_icon_holder"
                          onClick={() => {
                            setEditId(row?.id);
                            setEdit(true);
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faPencil}
                            className="edit_icon"
                          />
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(alldata?.current_page - 1) * alldata?.per_page + 1} To{" "}
            {Math.min(
              alldata?.current_page * alldata?.per_page,
              alldata?.total,
            )}{" "}
            Of {alldata?.total} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={alldata?.current_page}
            totalPages={alldata?.total_pages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Table;
